import { ClockIcon } from "@heroicons/react/24/outline";
import React from "react";
import { useDelayRecipeEditor } from "../delay-recipe-editor";
import { EditableWorkflow } from "../types";
import { actionTimingMode } from "./builder-helper";
import {
    WaitAmountControls,
    WaitDefault,
    WaitModeSelect,
    WaitSaveFailure,
    WaitStatus,
} from "./wait-controls";

const DEFAULT_WAIT: WaitDefault = { delay: 10, unit: "m" };

interface ActionTimingEditorProps {
    workflow: EditableWorkflow;
    verb: string;
    timeline: string | null;
    onCommit: (delayRecipe: string) => Promise<void>;
}

export const ActionTimingEditor: React.FC<ActionTimingEditorProps> = props => {
    const { workflow, verb, timeline, onCommit } = props;
    const control = useDelayRecipeEditor(workflow, onCommit);
    const mode = actionTimingMode(control.delay);

    if (!control.visible) {
        return null;
    }

    return (
        <div className="space-y-2">
            <div className="flex items-center gap-2 flex-wrap text-sm text-gray-600">
                <ClockIcon className="w-4 h-4 text-gray-400 shrink-0" />
                <span>{verb}</span>
                <WaitModeSelect control={control} defaultWait={DEFAULT_WAIT} />
                {mode === "immediately" ? (
                    <span>when the trigger fires</span>
                ) : (
                    <>
                        <span>of</span>
                        <WaitAmountControls control={control} minDelay={1} />
                        <span>from the trigger</span>
                    </>
                )}
                <WaitStatus control={control} timeline={timeline} />
            </div>
            <WaitSaveFailure control={control} />
        </div>
    );
};
